import { Badge } from "./ui/badge";

export function Logo() {
  return (
    <div className="pr-12 relative">
      <div className="font-headings text-2xl">Worksheep</div>
      <Badge className="absolute -top-2 right-0 bg-red-300 -rotate-3">
        beta
      </Badge>
    </div>
  );
}
